<template>
    <div class="list sell">

    <div class="auctionRegister">
        <h1 class="topTitle">コメント・売上管理</h1>
        <div class="btnBox" v-if="!isCommentFilter">
            <button class="btn" @click="filter_comment_count">2つ以上のコメントのみ表示</button>
        </div>
        <div class="btnBox" v-if="isCommentFilter">
            <button class="btn" @click="clear_comment_filter">全て表示</button>
        </div>
        <div class="container" >
            <div class="outer-menu">
                <input class="checkbox-toggle" v-model="isShowSerchBox" type="checkbox" />
                <div class="hamburger" :class="{ searchIcon: !isShowSerchBox}" @click="isShowSerchBox = !isShowSerchBox">
                    <div v-if="isShowSerchBox"></div>
                </div>
                <div class="menu">
                    <div class="searchArea">
                        <div class="searchBox">
                            <h2 class="itemTitle">検索</h2> 
                            <ul>
                                <li>
                                <label for="itemName">出品ID:</label>
                                <input type="text" placeholder="出品ID" id="sellId" v-model="serchItem.sellId" tabindex="1"/>
                            </li>
                            <li>
                                <label for="itemName">商品名:</label>
                                <input type="text" placeholder="商品名" id="itemName" v-model="serchItem.name" tabindex="1"/>
                            </li>
                            <li>
                                <label for="itemName">ユーザー名:</label>
                                <select class="sltBox" v-model="serchItem.userName">
                                    <option value="" disabled selected hidden>選択してください</option>
                                    <option v-for="item in userList" :value="item.USER_NAME" :key="item.USER_ID">
                                        {{ item.USER_NAME }}
                                    </option>
                                </select>
                                
                            </li>
                            <li class="serchDateBox">
                                <label for="str">出品日（売買成立日）:</label>
                                <datepicker
                                    v-model="serchItem.sellDateStr"
                                    format="yyyy年MM月dd日"
                                    placeholder="出品日（FROM）"
                                    input-class="searchDate"
                                    :language="ja"
                                    :disabled-dates="disabledDates"></datepicker>
                                ~
                                <datepicker
                                    v-model="serchItem.sellDateEnd"
                                    format="yyyy年MM月dd日"
                                    placeholder="出品日（TO）"
                                    input-class="searchDate"
                                    :language="ja"
                                    :disabled-dates="disabledDates"></datepicker>
                            </li>
                            <li class="serchDateBox">
                                <label for="serchIsSelled">成約済のみ表示:</label><br>
                               <input type="checkbox" v-model="serchItem.isSelled" id="serchIsSelled" >
                               <label class="checkbox03" for="serchIsSelled"></label>
                            </li>
                            <li class="serchDateBox">
                                <label for="price">いいね数:</label>
                                <input class="searchDate" type="number" placeholder="いいね数（FROM）" id="good" v-model="serchItem.goodCountStr" tabindex="2"/> ~ 
                                <input class="searchDate" type="number" placeholder="いいね数（TO）" v-model="serchItem.goodCountEnd" tabindex="2"/>
                            </li>
                            <li class="serchDateBox">
                                <label for="price">コメント数:</label>
                                <input class="searchDate" type="number" placeholder="コメント数（FROM）" id="price" v-model="serchItem.comCountStr" tabindex="2"/> ~ 
                                <input class="searchDate" type="number" placeholder="コメント数（TO）" v-model="serchItem.comCountEnd" tabindex="2"/>
                            </li>
                            <li class="serchDateBox">
                                <label for="str">最新コメント日:</label>
                                <datepicker
                                    v-model="serchItem.comDateStr"
                                    format="yyyy年MM月dd日"
                                    placeholder="最新コメント日（FROM）"
                                    input-class="searchDate"
                                    :language="ja"
                                    :disabled-dates="disabledDates"></datepicker>
                                ~
                                <datepicker
                                    v-model="serchItem.comDateEnd"
                                    format="yyyy年MM月dd日"
                                    placeholder="最新コメント日（TO）"
                                    input-class="searchDate"
                                    :language="ja"
                                    :disabled-dates="disabledDates"></datepicker>
                            </li>
                        </ul>
                        <div class="btnBox">
                            <button class="btn" @click="isShowSerchBox = !isShowSerchBox, clear()">クリア</button>
                            <button class="btn" @click="isShowSerchBox = !isShowSerchBox, serch()">検索</button>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="userBox">
                
            </div>
            <button data-v-20acca12="" class="btn" style="line-height: 1; background-color: rgb(11, 94, 215); border-color: rgb(10, 88, 202);" @click="allCheck">
                このページを全てチェックする
            </button>
            <div class="item-wrap">
                <table class="itemTable">
                    <tr>
                        <th class="listTitle">
                            削除
                        </th>
                        <th class="listTitle">
                            出品者名
                        </th>
                        <th class="listTitle">
                            最新コメント日時
                        </th>
                        <th class="listTitle">
                            商品ページへ
                        </th>
                        <th class="listTitle">
                            現在出品価格
                        </th>
                        <th class="listTitle">
                            いいね数
                        </th>
                        <th class="listTitle">
                            コメント数
                        </th>
                        
                        <th class="listTitle">
                            操作
                        </th>
                    </tr>
                    <tr v-for="(item ,index) in getItems" :key="index">
                        <td class="listItem">
                            <input type="checkbox" v-model="item.deleteFlg" :id="index + ((currentPage -1) *  perPage)+'_m'" value="1">
                            <label class="checkbox03" :for="index + ((currentPage -1) *  perPage)+'_m'"></label>
                        </td>
                        
                        <td class="listItem">
                            {{item.user_name}}
                        </td>
                        <td class="listItem">
                            {{item.COMMENT_DATE}}
                        </td>
                        <td class="listItem">
                            <a class="link" :href="'https://item.fril.jp/'+item.SELL_ID_HASH" target="_blank" rel="noopener noreferrer">商品ページへ移動</a>
                        </td>
                        <td class="listItem">
                            {{item.SELL_PRICE}}
                        </td>
                        <td class="listItem">
                            {{item.GOOD_COUNT}}
                        </td>
                        <td class="listItem">
                            {{item.COMMENT_COUNT}}
                        </td>
                        
                        <td class="listItem">
                            <button class="btn modif" @click="modal(item)">操作する</button>
                        </td>
                    </tr>
                    
                </table>
                <div>
                    <button class="btn modif" @click="delete_item">削除登録</button>
                </div>
                <div class="overlay" v-show="isModal">
                    <div class="modalodal">
                        <div class="swal2-popup swal2-modal swal2-show" style="display: grid;width: 100%;padding: 5px;height: 600px;overflow: auto;" >
                            <table class="itemTable">
                                <tr>
                                    <th class="listTitle name" style="width:30%">
                                        コメント送信者名
                                    </th>
                                    <th class="listTitle name" style="width:30%">
                                        コメント送信日時
                                    </th>
                                    <th class="listTitle com">
                                        コメント
                                    </th>
                                </tr>
                                <!-- <div v-id="vm.tmpComList">
                                {{vm.tmpComList.comments}}
                                </div> -->
                                <tr v-for="(item ,index) in tmpComList.comments" :key="index">
                                    <td class="listItem">
                                        {{item.USER_NAME}}
                                    </td>
                                    <td class="listItem">
                                        {{item.COMMENT_DATE}}
                                    </td>
                                    <td class="listItem">
                                        {{item.COMMENT}}
                                    </td>
                                </tr>
                            </table>
                            <div>
                                
                                <h5 @click="mType='com'">コメントを返信する</h5>
                                <div v-show="mType=='com'">
                                    <textarea rows="5" v-model="postItem.com.COMMENT"></textarea>

                                    <button class="btn modif" @click="setComment()">返信する</button>
                                </div>
                            </div>

                            <div>
                                <h5 @click="mType='edit'">この商品情報を変更する</h5>
                                <div v-show="mType=='edit'">
                                    <label>
                                        商品価格
                                        <input type="text" v-model="postItem.edit.PRICE">
                                    </label>
                                    <label>
                                        商品名
                                        <input type="text" v-model="postItem.edit.TITLE">
                                    </label>
                                    <button class="btn modif" @click="editItem()">更新する</button>

                                </div>
                            </div>
                            
                            <div class="swal2-actions">
                            <button class="swal2-cancel swal2-styled" @click="rePage">戻る</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pdgTop10">
                    <vuejs-paginate
                    :page-count="getPaginateCount"
                    :prev-text="'<'"
                    :next-text="'>'"
                    :click-handler="paginateClickCallback"
                    :container-class="'pagination justify-content-center'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :first-last-button="true"
                    :first-button-text="'<<'"
                    :last-button-text="'>>'"
                    ></vuejs-paginate>
                </div>
                
            </div>
            <div class="btnBox subArea">
                <button class="btn repage" @click="returnPage">戻る</button>
            </div>
        </div>
    </div>
    </div>
</template>
<script>
import {userRepository} from '@/Repositories/userRepository.js'
import {w_auction_repository} from '@/Repositories/u009_r_w_auction_repository.js'
import {coms_repository} from '@/Repositories/u003_r_coms_repository.js'
import {recoms_repository} from '@/Repositories/u004_r_recoms_repository.js'
import {edit_item_repository} from '@/Repositories/u005_r_edit_item_repository.js'

import VueJsPaginate from 'vuejs-paginate';
import Datepicker from 'vuejs-datepicker';
import {ja} from 'vuejs-datepicker/dist/locale';
import moment from 'moment';
export default {
    
  data() {
        return {
            /******************
             * Datepicker設定
            ******************/
            ja:ja,
            disabledDates:{
                from:new Date()
            },
            /******************
             * 表示フラグ
            ******************/
            isShowSerchBox:false,
            isDisabled:true,
            isModal:false,
            mType:'',
            isCommentFilter:false,
            /******************
             * ユーザー情報
            ******************/
            userInfo:{},
            userList:[],
            setUserId:'',
            tmpSiteType:null,
            /******************
             * 商品情報
            ******************/
            auctionList:[],
            tmpAuctionList:[],
            comList:[],
            tmpComList:[],
            itemList:[],
            commentList:[],
            postItem:{
                com:{},
                edit:{}
            },
            /******************
             * 検索ボックス
            ******************/
            serchItem : {
                sellId:null,
                name:null,
                sellDateStr:null,
                sellDateEnd:null,
                goodCountStr:null,
                goodCountEnd:null,
                comCountStr:null,
                comCountEnd:null,
                isSelled:false
            },
            /******************
             * 一時変数
            ******************/
            tmpSellId:null,
            tmpComment:null,
            /******************
             * ページング設定
            ******************/
            currentPage: 1,
            perPage: 20
        }
  },
    components: {
        "vuejs-paginate": VueJsPaginate,
        Datepicker,
    },
  methods:{
    allCheck(){
        let start = (this.currentPage - 1) * this.perPage;
        let end = this.currentPage * this.perPage;
        var items = this.tmpAuctionList.slice(start, end);
        for(var item of items){
            item.deleteFlg = true;            
        }
        this.tmpAuctionList.splice();
    },
    filter_comment_count(){
        let vm = this;
        vm.tmpAuctionList = [...vm.auctionList];
        vm.tmpAuctionList = vm.tmpAuctionList.filter((item, i, arr)=> {
            return item.COMMENT_COUNT > 1
        });
        vm.isCommentFilter = true;
    },
    clear_comment_filter(){
        let vm = this;
        vm.tmpAuctionList = [...vm.auctionList];
        vm.isCommentFilter = false;
    },
    async delete_item(){
          let vm = this;
        var deleteArr = vm.tmpAuctionList.filter(x=> x.deleteFlg);

        var delList = deleteArr.map(x=> x.SELL_ID).join('\',\'');
        await cApiRepsitory.methods.post({
            "items":delList,
            "type":'deleteCom'
        }).then(res=>{
            vm.$swal("削除登録しました", '',"success")
            vm.tmpComList.comments = res.data
        })
    },
      returnPage(){
          let vm = this;
            vm.$router.back();
        },
        
      serch(){
        let vm = this;
        vm.tmpAuctionList = [...vm.auctionList];
        if(vm.serchItem.sellId){
        //出品IDフィルター
            vm.tmpAuctionList = vm.tmpAuctionList.filter((item, i, arr)=> {
                return item.SELL_ID == vm.serchItem.sellId
            })
            
        }
        if(vm.serchItem.name){
            
            //名前フィルター
            vm.tmpAuctionList = vm.tmpAuctionList.filter((item, i, arr)=> {
                return item.ITEM_TITLE.match(vm.serchItem.name) != null
            })
        }
        if(vm.serchItem.userName){
            
            //ユーザー名フィルター
            vm.tmpAuctionList = vm.tmpAuctionList.filter((item, i, arr)=> {
                return item.USER_NAME == vm.serchItem.userName;
            })
        }
        if(vm.serchItem.sellDateStr){
            //出品日フィルター（開始）
            var str= moment(vm.serchItem.sellDateStr).format('YYYYMMDD');
            vm.tmpAuctionList = vm.tmpAuctionList.filter(function(item) {
                var putDate = moment(item.formatDate,"YYYY年 MM月 DD日").format('YYYYMMDD');
                return Number(putDate) >= Number(str) 
            });
        }
        if(vm.serchItem.sellDateEnd){
            //出品日フィルター（終了）
            var end= moment(vm.serchItem.sellDateEnd).format('YYYYMMDD');
            vm.tmpAuctionList = vm.tmpAuctionList.filter(function(item) {
                var putDate = moment(item.formatDate,"YYYY年 MM月 DD日").format('YYYYMMDD');
                return Number(putDate) <= Number(end) ;
            });
        }

        if(vm.serchItem.goodCountStr){
            //いいね数フィルター（開始）
            vm.tmpAuctionList = vm.tmpAuctionList.filter((item, i, arr)=> {
                return Number(item.GOOD_COUNT) >= Number(vm.serchItem.goodCountStr);
            });
        }
        if(vm.serchItem.goodCountEnd){
            //いいね数フィルター（終了）
            vm.tmpAuctionList = vm.tmpAuctionList.filter((item, i, arr)=> {
                return  Number(item.GOOD_COUNT) <= Number(vm.serchItem.goodCountEnd) ;
            });
        }
        if(vm.serchItem.comCountStr){
            //コメント数フィルター（開始）
            vm.tmpAuctionList = vm.tmpAuctionList.filter((item)=> {
                return Number(item.COMMENT_COUNT) >= Number(vm.serchItem.comCountStr);
            });
        }
        if(vm.serchItem.comCountEnd){
            //コメント数フィルター（終了）
            vm.tmpAuctionList = vm.tmpAuctionList.filter((item)=> {
                return Number(item.COMMENT_COUNT) <= Number(vm.serchItem.comCountEND) ;
            });
        }

        if(vm.serchItem.comDateStr){
            //最新コメント日フィルター（開始）
            var str= moment(vm.serchItem.comDateStr).format('YYYYMMDD');
            vm.tmpAuctionList = vm.tmpAuctionList.filter(function(item) {
                
                return item.COMMENT_DAY != "-" && Number(moment(item.COMMENT_DAY,"YYYY年 MM月 DD日").format("YYYYMMDD")) >= Number(str);
            });
        }
        if(vm.serchItem.comDateEnd){
            //最新コメント日フィルター（終了）
            var end= moment(vm.serchItem.comDateEnd).format('YYYYMMDD');
            vm.tmpAuctionList = vm.tmpAuctionList.filter(function(item) {
                return item.COMMENT_DAY != "-" && Number(moment(item.COMMENT_DAY,"YYYY年 MM月 DD日").format("YYYYMMDD")) <= Number(end);
            });
        }

        if(vm.serchItem.isSelled){
            //成約済みのみフィルター
            vm.tmpAuctionList = vm.tmpAuctionList.filter((item)=> {
                return item.IS_SELLED
            });
        }
    },
    clear(){
        this.tmpAuctionList = [...this.auctionList];
        this.serchItem ={};
    },
    paginateClickCallback (pageNum) {
        this.currentPage = Number(pageNum);
    },
    rePage(){
        var vm = this;
        vm.postItem = {
            com:{},
            edit:{}
        }
        vm.tmpComList.comments = [];
        this.isModal = false;
    },
    async modal(item){
        let vm = this;
        vm.tmpComList =item;
        vm.postItem = {
            com:{},
            edit:{}
        }
        vm.postItem.edit ={
            USER_ID : item.USER_ID,
            PARENT_ID : vm.userInfo.USER_ID,
            SELL_ID :item.SELL_ID,
            PRICE : item.SELL_PRICE,
            TITLE : item.TITLE,
            DONE : '0'
        };
        vm.postItem.com ={
            USER_ID : item.USER_ID,
            PARENT_ID : vm.userInfo.USER_ID,
            SELL_ID :item.SELL_ID,
            COMMENT : '',
            DONE : '0'
        };
        await coms_repository.get(item.SELL_ID).then(res=>{
            vm.tmpComList.comments = res.data
        })
        vm.isModal = true;
    },
    setComment(){
        let vm = this;
        console.log(vm.postItem.com);
        recoms_repository.upd(vm.postItem.com).then(res=>{
            vm.$swal("コメント返信登録しました。", '',"success")
            vm.postItem = {
                com:{},
                edit:{}
            }
            vm.tmpComList = [];
        vm.isModal = false;
        });
    },
    editItem(){
        let vm = this;
        edit_item_repository.upd(vm.postItem.edit).then(res=>{
            vm.$swal("商品情報を登録しました。", '',"success")
            console.log(res);
            vm.tmpComList = [];
            vm.postItem = {
                com:{},
                edit:{}
            }
            vm.isModal = false;
        });
    },    
      init(){
            let vm =this;
            vm.userInfo = vm.$functions.getSStorage('userInfo');
            userRepository.methods.getChild()
            .then(async res=>{
                var data = res.data;
                vm.userList = data;
                w_auction_repository.get(vm.userInfo.USER_ID)
                .then(res=>{
                    vm.auctionList = res.data;
                    for(var auc of vm.auctionList){
                        auc.user_name = vm.userList.find(x=> x.USER_ID == auc.USER_ID).USER_NAME;
                    }
                    vm.tmpAuctionList = vm.auctionList;
                });
             });
             
      }
  },
  computed:{
      sum() {
        return this.tmpAuctionList.reduce((sum, item) => {
            if(item.IS_SELLED){
                sum += Number(item.SELL_PRICE);
            }
            return sum
        }, 0);
    },
        getPaginateCount: function () {
            return Math.ceil(this.tmpAuctionList.length / this.perPage);
        },
        getItems () {
            console.log('aaa');
            if(!this.auctionList.length) return;
            if(this.auctionList.length == 0) return;
            let start = (this.currentPage - 1) * this.perPage;
            let end = this.currentPage * this.perPage;
            return this.tmpAuctionList.slice(start, end);
        }
    },
   created:async function(){
        let vm =this;
        await vm.init();

  }
}
</script>

<style lang="scss">
@import "../style/sell.scss";
    
    @import "../style/auctionRegister.scss";
</style>